import React from 'react';
import CompliancePage from '../components/CompliancePage';
import { COMPLIANCE_PAGES } from '../config';

const AboutUsPage = () => {
  return <CompliancePage pageData={COMPLIANCE_PAGES.aboutUs} />;
};

export default AboutUsPage;
